import { render, staticRenderFns } from "./BgProgreess.vue?vue&type=template&id=3d6a0af2&scoped=true"
import script from "./BgProgreess.vue?vue&type=script&lang=js"
export * from "./BgProgreess.vue?vue&type=script&lang=js"
import style0 from "./BgProgreess.vue?vue&type=style&index=0&id=3d6a0af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6a0af2",
  null
  
)

export default component.exports